import { IntakeDependencies, IntakeDependentFeature } from "../types/client-intake";

export const INTAKE_APPOINTMENT_TYPE_ASSOCIATION_DESCRIPTION =
  "This intake form will be automatically sent for any of the following appointment types";

const CLIENT_PROFILE_AND_LABS = [IntakeDependentFeature.ClientProfile, IntakeDependentFeature.Labs];
const LABS = [IntakeDependentFeature.Labs];
const BILLING_AND_LABS = [
  IntakeDependentFeature.Billing,
  IntakeDependentFeature.VerifyInsurance,
  IntakeDependentFeature.Labs,
];

/**
 * Intake sections, then the questions inside them, by linkId, that other features read data from.
 * A removed question is reported only while its section is still in the intake.
 */
export const INTAKE_DEPENDENCIES: IntakeDependencies = {
  identifyingInformation: CLIENT_PROFILE_AND_LABS,
  demographic: CLIENT_PROFILE_AND_LABS,
  contactInformation: CLIENT_PROFILE_AND_LABS,
  billingInformation: BILLING_AND_LABS,
  identifyingInformationFirstName: CLIENT_PROFILE_AND_LABS,
  identifyingInformationLastName: CLIENT_PROFILE_AND_LABS,
  identifyingInformationDOB: CLIENT_PROFILE_AND_LABS,
  demographicLanguage: LABS,
  demographicLegalSex: LABS,
  demographicSexAssignedAtBirth: LABS,
  contactInformationAddress: LABS,
  contactInformationCity: LABS,
  contactInformationState: LABS,
  contactInformationZipCode: LABS,
  contactInformationPhoneFormsetPhone: LABS,
  contactInformationPhoneFormsetType: LABS,
  billingInformationPaymentMethod: BILLING_AND_LABS,
  billingInformationHealthInsurance: BILLING_AND_LABS,
  billingInformationInsuranceCompany: BILLING_AND_LABS,
  billingInformationInsuranceId: BILLING_AND_LABS,
  billingInformationSubscriberRelationship: BILLING_AND_LABS,
};
